import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import { LunchLitelyClient } from '@peekops/lunch-litely';
import angular, { IPromise } from 'angular';

export interface FlagContext {
  userId?: string;
  tenantId?: string;
  sessionId?: string;
  attributes?: Record<string, unknown>;
}

export class LunchLitelyService {
  static $inject = ['$q', 'lunchLitelyClient', 'AuthenticationService'];

  constructor(
    private $q: angular.IQService,
    private client: LunchLitelyClient | null,
    private authenticationService: AuthenticationService,
  ) {}

  isEnabled(key: string, ctx?: FlagContext, defaultValue?: boolean): IPromise<boolean> {
    return this.client
      ? this.$q.when(this.client.isEnabled(key, { ...this.defaultContext(), ...ctx }, defaultValue))
      : this.$q.when(defaultValue ?? false);
  }

  getVariation<T>(key: string, defaultValue: T, ctx?: FlagContext): IPromise<T> {
    return this.client
      ? this.$q.when(this.client.getVariation(key, defaultValue, { ...this.defaultContext(), ...ctx }))
      : this.$q.when(defaultValue);
  }

  evaluate(key: string, ctx?: FlagContext): IPromise<unknown> {
    return this.client
      ? this.$q.when(this.client.evaluate(key, { ...this.defaultContext(), ...ctx }))
      : this.notConfigured();
  }

  evaluateBulk(keys: string[], ctx?: FlagContext): IPromise<Record<string, unknown>> {
    return this.client
      ? this.$q.when(this.client.evaluateBulk(keys, { ...this.defaultContext(), ...ctx }))
      : this.notConfigured();
  }

  private defaultContext(): FlagContext {
    const user = this.authenticationService.getUserFromCookie();
    return {
      ...(user?.tenantId != null && { tenantId: String(user.tenantId) }),
      ...(user?.id != null && { userId: String(user.id) }),
    };
  }

  private notConfigured() {
    return this.$q.reject(new Error('LunchLitelyService is not configured'));
  }
}

export const LunchLitelyServiceModule = angular
  .module('acme.common.service.lunchLitely', [AuthenticationServiceModule])
  .factory('lunchLitelyClient', [
    '$window',
    ($window: Window): LunchLitelyClient | null => {
      const config = $window.CONFIG?.lunchLitely;

      if (config?.baseUrl) {
        return new LunchLitelyClient({
          baseUrl: config.baseUrl,
          apiKey: $window.LL_API_KEY ?? '',
        });
      }

      return null;
    },
  ])
  .service('LunchLitelyService', LunchLitelyService).name;
